import request from '@/utils/request'


// 查询用户设备绑定列表
export function listDevice(query) {
  return request({
    url: '/mibo/user-device/list',
    method: 'get',
    params: query
  })
}

// 查询用户设备绑定分页
export function pageDevice(query) {
  return request({
    url: '/mibo/user-device/page',
    method: 'get',
    params: query
  })
}

// 查询用户设备绑定详细
export function getDevice(data) {
  return request({
    url: '/mibo/user-device/detail',
    method: 'get',
    params: data
  })
}

// 新增用户设备绑定
export function addDevice(data) {
  return request({
    url: '/mibo/user-device/add',
    method: 'post',
    data: data
  })
}

// 修改用户设备绑定
export function updateDevice(data) {
  return request({
    url: '/mibo/user-device/edit',
    method: 'post',
    data: data
  })
}

// 删除用户设备绑定
export function delDevice(data) {
  return request({
    url: '/mibo/user-device/delete',
    method: 'post',
    data: data
  })
}
